export interface ContentType {
  value: string;
  label: string;
  supported: boolean;
  description?: string;
}

export const CONTENT_TYPE_OPTIONS: ContentType[] = [
  {
    value: "image",
    label: "Single Image",
    supported: true,
    description: "Upload your own image with 1080x1080 pixel",
  },
  {
    value: "video",
    label: "Single Video",
    supported: false,
    description: "Video content is not currently supported",
  },
  {
    value: "text",
    label: "Text Only",
    supported: true,
    description: "Text-based content without media",
  },
];

export const getSupportedContentTypes = (): ContentType[] => {
  return CONTENT_TYPE_OPTIONS.filter((option) => option.supported);
};

export const getUnsupportedContentTypes = (): ContentType[] => {
  return CONTENT_TYPE_OPTIONS.filter((option) => !option.supported);
};
